import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import CustomRangepicker from "../../common/rangepicker";
import { TrimText, capitalizeFirstLetter, formateDateWithMonth } from "../../../../utils/commonfunction";
import * as photoroomUsageServices from "../../services/photoroomUsage.services";
import { useTranslation } from "react-i18next";

const formatSize = (bytes) => {
  const size = Number(bytes);
  if (!size) return "N/A";
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
};

const PhotoroomUsageTable = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState();
  const [totalCalls, setTotalCalls] = useState(0);
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);
  const [viewRow, setViewRow] = useState(null);
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: "Photoroom Usage", url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      photoroomUsageServices
        .List(formData)
        .then((data) => {
          setDataLength(data.data.total_records);
          setTotalCalls(data.data.total_api_calls || 0);
          setList(data && data.data && data.data.list ? data.data.list : []);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(getData);
  }, [location, sorting, search, globalsearch]);

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center">
                <h6 className="main-content-label me-3 mb-0">Photoroom API Usage</h6>
                <span className="btn ripple btn-main-primary signbtn btn-sm">Total API calls: {totalCalls}</span>
              </div>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input type="search" className="form-control" value={globalsearch} placeholder="Search name or email" onChange={(e) => setGlobalSearch(e.target.value)} />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker GetDateRange={(e) => prepareSearch("createdAt", e)} resetdate={resetdate} />
                </div>
                <button className="btn ripple btn-secondary" onClick={resetFilter}>
                  {t("Reset")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">{t("list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>User Name</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User Email</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Image Size</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="image_size" />
                      </div>
                    </th>
                    <th>Status</th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>Date</span>
                        <Sorting sort={sorting} defaultSorting={defaultSorting} handleSort={handleSort} column="createdAt" />
                      </div>
                    </th>
                    <th className="action_head">{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={7}>
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length ? (
                    list.map((row, i) => (
                      <tr key={row._id}>
                        <td>{(page - 1) * itemperpage + i + 1}</td>
                        <td>{row?.name ? capitalizeFirstLetter(TrimText(row.name, 40)) : "N/A"}</td>
                        <td>{row?.email ? row.email.toLowerCase() : "N/A"}</td>
                        <td>{formatSize(row?.image_size)}</td>
                        <td>
                          {row?.status === "failed" ? (
                            <span className="btn ripple btn-secondary btn-sm" title={row?.error || ""}>
                              Failed
                            </span>
                          ) : (
                            <span className="btn ripple btn-main-primary signbtn btn-sm">Success</span>
                          )}
                        </td>
                        <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                        <td>
                          <button className="btn ripple btn-main-primary signbtn" disabled={!row?.image_url} onClick={() => setViewRow(row)}>
                            View Image
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        {t("msg_no_records")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "PageTable", path: "/admin/photoroom-usage/list" }]} /> : ""}
          </div>
        </div>
      </div>

      {viewRow && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }} onClick={() => setViewRow(null)}>
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">
                  {viewRow.name ? capitalizeFirstLetter(viewRow.name) : "N/A"} ({viewRow.email || "N/A"}) · {formatSize(viewRow.image_size)}
                </h6>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setViewRow(null)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3 text-center align-items-start">
                  <div className={viewRow.result_url ? "col-6" : "col-12"}>
                    <p className="mb-2">
                      <b>Uploaded by user</b>
                    </p>
                    <img src={viewRow.image_url} alt="Uploaded by user" style={{ maxWidth: "100%", maxHeight: "300px", objectFit: "contain", display: "block", margin: "0 auto" }} />
                  </div>
                  {viewRow.result_url && (
                    <div className="col-6">
                      <p className="mb-2">
                        <b>Background removed result</b>
                      </p>
                      <img src={viewRow.result_url} alt="Result" style={{ maxWidth: "100%", maxHeight: "300px", objectFit: "contain", background: "#eee", display: "block", margin: "0 auto" }} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoroomUsageTable;
